export default async (context) => {
    // get запрос на получение списка музыки

    let music = await context.$axios.get('/music')
    context.musics = music.data
    context.musics = context.musics.map((item, index) => ({
        status: false,
        play: false,
        type: 'music',
        selected: context.music.index === index ? true : false,
        index: index,
        ...item

    }));


    context.$nextTick(() => {
        context.rendering = true
    })
}